import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { StyledPaper, StyledTable, StyledTableRow, StyledTableCell } from '../../../uiComponents/MuiTable/StyledTable.js'
import MuiTablePagination from '../../../uiComponents/MuiTable/MuiTablePagination';
import MuiTableHeader from '../../../uiComponents/MuiTable/MuiTableHeader.js';
import { stableSort, getComparator, handleRequestSort, handleChangePage, handleChangeRowsPerPage } from '../../../uiComponents/MuiTable/MuiHelper';
import {
  TableBody,
  TableContainer,
} from '@mui/material';

const CompareAnalyteDataTable = ({ data }) => {
  if (!data || data.length === 0) return null;

  const [order, setOrder] = useState('asc'); //default sort direction
  const [orderBy, setOrderBy] = useState('program_id'); //default sort column for table
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const headCells = [
    { label: 'Program ID', id: 'program_id', numeric: false, disablePadding: false },
    { label: 'Mean', id: 'mean', numeric: false, disablePadding: false },     
    { label: 'Median', id: 'median', numeric: true, disablePadding: false, align: 'left' },
    { label: 'Std. Dev.', id: 'stddev', numeric: false, disablePadding: false },
    { label: 'Min', id: 'min', numeric: false, disablePadding: false },
    { label: 'Q1', id: 'q1', numeric: false, disablePadding: false },
    { label: 'Q3', id: 'q3', numeric: false, disablePadding: false },
    { label: 'Max', id: 'max', numeric: false, disablePadding: false },
    { label: 'N', id: 'n', numeric: false, disablePadding: false },
  ];

  return (
    <>
    <TableContainer component={StyledPaper}>
      <StyledTable 
        size='small'
        aria-label="compare analyte table"
        key={JSON.stringify(data)} 
      >
        <MuiTableHeader 
          headCells={headCells} 
          order={order}  
          orderBy={orderBy} 
          onRequestSort={(event, property) => handleRequestSort(event, property, order, orderBy, setOrder, setOrderBy)}
        />
        <TableBody>
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
            return (
              <StyledTableRow key={index}>
                <StyledTableCell>{row.program_id}</StyledTableCell>
                <StyledTableCell>{row.mean}</StyledTableCell>
                <StyledTableCell>{row.median}</StyledTableCell>
                <StyledTableCell>{row.stddev}</StyledTableCell>
                <StyledTableCell>{row.min}</StyledTableCell>
                <StyledTableCell>{row.q1}</StyledTableCell>
                <StyledTableCell>{row.q3}</StyledTableCell>
                <StyledTableCell>{row.max}</StyledTableCell>
                <StyledTableCell>{row.n}</StyledTableCell>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </StyledTable>
    </TableContainer>
    <MuiTablePagination 
      rowsPerPage={rowsPerPage}
      page={page}
      count={data.length}
      onPageChange={(event, newPage) => handleChangePage(event, newPage, setPage)}
      onRowsPerPageChange={(event) => handleChangeRowsPerPage(event, setRowsPerPage, setPage)} 
    />
    </>
  );
};

CompareAnalyteDataTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      program_id: PropTypes.string.isRequired,
      mean: PropTypes.number.isRequired,
      median: PropTypes.number.isRequired,
      stddev: PropTypes.number.isRequired,
      min: PropTypes.number.isRequired,
      q1: PropTypes.number.isRequired,
      q3: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired,
      n: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default CompareAnalyteDataTable;
